import * as Yup from "yup"
import { TRANSLATION_INDEX_GLOBAL } from "../../config/translation"

export const deleteScheme = Yup.object().shape({})

export const addUpdateScheme = Yup.object().shape({
  nombre: Yup.string().required(TRANSLATION_INDEX_GLOBAL.REQUIRED)
})
